



































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapState } from 'vuex'
import PerfectScrollbar from 'perfect-scrollbar'
import AsideTools from './AsideTools.vue'
import AsideMenuList from './AsideMenuList.vue'
import { UserModule } from '../store/modules/user'
import { AppModule } from '../store/modules/app'

@Component({
  name: 'AsideMenu',
  components: { AsideTools, AsideMenuList }
})
export default class AsideMenu extends Vue {
  private ps: PerfectScrollbar;
  
  @Prop({
    type: Array,
    default: () => []
  })
  menu;

  @Prop({
    type: Array,
    default: () => []
  })
  menuBottom;

  @Prop({
    type: Boolean,
    default: false
  })
  isSecondary;

  @Prop({
    type: String,
    default: null
  })
  label;

  @Prop({
    type: String,
    default: null
  })
  icon;

  get isAsideVisible() {
    return AppModule.isAsideVisible
  }

  get isAsideExpanded() {
    return AppModule.isAsideExpanded
  }

  get isAsideMobileExpanded() {
    return AppModule.isAsideMobileExpanded
  }

  mounted() {
    this.ps = new PerfectScrollbar(this.$refs.menuContainer as Element)
  }

  menuClick(item) {
    this.$emit('menu-click', item)
  }

  psUpdate() {
    if (this.ps) {
      this.ps.update()
    }
  }

  close() {
    this.$emit('close')
  }
}
